import UltMeta, { Meta } from "./UltMeta/index";

// 埋点类型
class TrackType extends UltMeta {
    ELEMENT_CLICK = new Meta(1, "元素点击")
    OPERATION_BEHAVIOR = new Meta(2, "操作行为")
    PAGE_STAY_DURATION = new Meta(3, "页面停留时长")
    PV_UV = new Meta(4, "页面浏览（PV/UV）")
}

export const TRACK_TYPE = new TrackType()


// 埋点类型
class TrackTypeUser extends UltMeta {
    ELEMENT_CLICK = new Meta(1, "元素点击")
    OPERATION_BEHAVIOR = new Meta(2, "操作行为")
    PV_UV = new Meta(3, "页面停留时长")
}

export const TRACK_TYPE_USER = new TrackTypeUser()